
import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import CreateNonTransferableDialog from "@/components/non-transferables/CreateNonTransferableDialog.vue";
import AddBtn from "@/components/generic/buttons/add-btn.vue";

@Component({
  components: { AddBtn, CreateNonTransferableDialog },
})
export default class NonTransferablesTab extends Vue {

  @Prop({default: null})
  public building: any;

  @Getter private canDoInEnvCompany: (right: string) => boolean;
  @Getter private isMobile: boolean;

  private nonTransferables: any[] = [];
  private nonTransferablesHeaders: object[] = [];
  private loadingNonTransferables: boolean = false;
  private createNonTransferableDialog: boolean = false;

  private mounted() {
    this.nonTransferablesHeaders = [
      {value: "name", text: this.$tc("form.name"), sortable: true},
      {value: "type", text: this.$t("form.type"), sortable: true},
      {value: "provider", text: this.$t("form.provider"), sortable: true},
      {value: "createdAt", text: this.$t("form.createdAt"), sortable: true},
    ];
    this.getNonTransferables();
  }

  private getNonTransferables(): Promise<any> {
    this.loadingNonTransferables = true;
    return this.$store.dispatch("buildings/getNonTransferablesByBuildingId", {
      buildingId: this.building.id,
    }).then((res) => {
      this.nonTransferables = res.rows;
    }).finally(() => {
      this.loadingNonTransferables = false;
      this.$emit("loaded");
    });
  }

  private rowClick(row) {
    this.$router.push({
      name : "non-transferable",
      params: { id: row.id },
    });
  }
}
